import axios from "axios";
import routes from "../../configs/api";

const register = (data) => {
  return new Promise((resolve, reject) => {
    const URL = routes.REGISTER;
    axios
      .post(URL, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default register;